import script from "./ReferralAdModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralAdModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReferralAdModal.vue?vue&type=style&index=0&id=31530ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31530ee2"]])

export default __exports__